import { render, staticRenderFns } from "./AssetType.vue?vue&type=template&id=fb0f9224&scoped=true"
import script from "./AssetType.vue?vue&type=script&lang=js"
export * from "./AssetType.vue?vue&type=script&lang=js"
import style0 from "./AssetType.vue?vue&type=style&index=0&id=fb0f9224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0f9224",
  null
  
)

export default component.exports